<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="班级名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['name']" placeholder="请输入班级名称"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="年级名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                ref="gradeId"
                placeholder="请选择年级"
                v-model="model.gradeId"
                dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
                style="width: 100%"
                allowClear
                @input="changeGrade"
              ></j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="班主任名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                show-search
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                v-model="model.headteacherId"
                placeholder="请选择班主任"
                @search="handleUserSearch"
                @change="handleUserChange"
                allowClear
              >
                <a-select-option v-for="d in userData" :key="d.id">
                  {{ d.realname }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['sortOrder']" placeholder="请输入排序"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import pick from 'lodash.pick'
import JFormContainer from '@/components/jeecg/JFormContainer'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import JDate from '@/components/jeecg/JDate'
import Vue from "vue";
import {TENANT_ID} from "@/store/mutation-types";

export default {
  name: 'SchoolClassForm',
  components: {
    JFormContainer,
    JSearchSelectTag,
    JDate
  },
  data() {
    return {
      form: this.$form.createForm(this),
      model: {
        gradeId: "",
        headteacherId: ""
      },
      userData: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: '/aigoes/schoolClass/add',
        edit: '/aigoes/schoolClass/edit',
        queryById: '/aigoes/schoolClass/queryById'
      }
    }
  },
  created() {
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'name',
            'headteacherId',
            'teacherName',
            'gradeId',
            'gradeName',
            'sortOrder'
          )
        )
      })
      this.handleUserSearch("", this.model);
    },
    submitForm() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          let formData = Object.assign(this.model, values)
          console.log('表单提交数据', formData)
          httpAction(httpurl, formData, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
    /**
     * 修改年级
     * @param val
     */
    changeGrade(val){
      this.$refs['gradeId'].dictOptions.forEach(item => {
        if(item.value === val){
          this.model.gradeName = item.text;
        }
      })
    },
    /**
     * 查询老师
     * @param val
     * @param name
     */
    handleUserSearch(val, initData){
      getAction("/sys/user/list", {'realname': '*'+val+'*','userIdentity_FindInSet': '3','relTenantIds_FindInSet':Number(Vue.ls.get(TENANT_ID))}).then(res => {
        this.userData = res.result.records
        if(initData.headteacherId){
          this.userData.push({"id": initData.headteacherId, "realname": initData.teacherName})
        }
      })
    },
    /**
     * 修改班主任
     * @param value
     */
    handleUserChange(val) {
      this.userData.forEach(item => {
        if(item.id === val){
          this.model.teacherName = item.realname;
        }
      })
    }
  }
}
</script>